import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import remark from 'remark'
import recommended from 'remark-preset-lint-recommended'
import remarkHtml from 'remark-html'

const StAvatar = styled.div`
  position: relative;
  padding-bottom: 100%;
  .gatsby-image-wrapper {
    position: absolute !important;
    width: 100% !important;
    height: 100% !important;
    top: 0;
    left: 0;
  }
`

const StParagraphs = styled.div`
  p {
    padding-bottom: 2rem;
    letter-spacing: -0.4px;
    @media (max-width: 800px) {
      padding-bottom: 1rem;
    }
  }
`

const Author = ({ data }) => {
  console.log('>>>data', data)
  const { avatar, fullname, title, bio } = data
  const htmlbio = remark()
    .use(recommended)
    .use(remarkHtml)
    .processSync(bio)
    .toString()
  return (
    <div className="wrap-author grid grid-cols-8 sm:gap-6 gap-2 sm:px-8 px-2 pt-2 pb-8">
      <div className="wrap-img sm:col-span-1 col-span-2">
        <StAvatar>
          <Img
            className="rounded-full block w-full"
            fixed={avatar.childImageSharp.fixed}
          />
        </StAvatar>
      </div>
      <div className="wrap-author-text sm:col-span-7 col-span-6">
        <h4 className="font-bold">{fullname}</h4>
        {title && <h4 className="block">{title}</h4>}

        <StParagraphs
          className=""
          dangerouslySetInnerHTML={{ __html: htmlbio }}
        />
      </div>
    </div>
  )
}

export default Author
